import { Modal } from "antd"
import React from "react"
import GenericButton from "./GenericButton"

export default function GenericModal({ ...props }) {
  return (
    <div>
      <Modal
        centered
        visible={props.visibleState}
        footer={null}
        onCancel={() => props.updateVisibility()}
        closeIcon={props.closeIcon}
        className={props.rootClassAntCustom}
        zIndex={props.zIndex}
        closable={props.closeIconVisible}
        wrapClassName={props.wrapClassName}
      >
        {props.component}
        {props.showButton ? (
          <GenericButton
            title={props.buttonText}
            buttonStyle={props.buttonStyle}
            onClick={() => props.buttononClick()}
            className={props.buttonWrapper}
          />
        ) : (
          ""
        )}
      </Modal>
    </div>
  )
}
